import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IDmLoaiLienHeActionTypes } from "../../action-types/crm-category/IDmLoaiLienHeActionTypes";
import { IDmLoaiLienHeReducer } from "../../page-state-model/crm-category/IDmLoaiLienHeReducer";

const iniState: IDmLoaiLienHeReducer = {
    status: ePageBaseStatus.is_not_initialization,
    loaiLienHes: []
}

export const dmLoaiLienHeReducer = (state: IDmLoaiLienHeReducer = iniState, action: IDmLoaiLienHeActionTypes): IDmLoaiLienHeReducer => {
    switch (action.type) {
        case "DM_LOAI_LIEN_HE_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DM_LOAI_LIEN_HE_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                loaiLienHes: action.payload
            }
        case "DM_LOAI_LIEN_HE_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                loaiLienHes: []
            }
        case "DM_LOAI_LIEN_HE_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "DM_LOAI_LIEN_HE_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "DM_LOAI_LIEN_HE_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "DM_LOAI_LIEN_HE_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "DM_LOAI_LIEN_HE_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "DM_LOAI_LIEN_HE_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "DM_LOAI_LIEN_HE_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "DM_LOAI_LIEN_HE_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}
